import './mdb/scss/mdb.pro.scss'; // CSS 파일 경로 수정
import * as mdb from './mdb/js/mdb.pro.umd.js';  // JS 파일 경로 수정
window.mdb = mdb;